import calendarPlan from '@/store/modules/calendar-plan/calendar-plan'
import calendarPlanCreate from '@/store/modules/calendar-plan/calendar-plan-create'
import calendarPlanEdit from '@/store/modules/calendar-plan/calendar-plan-edit'
import calendarPlanDelete from '@/store/modules/calendar-plan/calendar-plan-delete'
import calendarPlanKindsSport from '@/store/modules/calendar-plan/calendar-plan-kinds-sport'

export default {
  calendarPlan,
  calendarPlanCreate,
  calendarPlanEdit,
  calendarPlanDelete,
  calendarPlanKindsSport,
}
